export const HELP_GUIDES = [
  {
    id: "workflow",
    title: "Workflow",
    subtopics: [
      {
        id: "pre-charting",
        title: "Pre-charting",
        articles: [
          {
            id: "pre-charting-guide",
            title: "How to Use Pre-charting",
            description:
              "Step-by-step guide to pre-charting patient visits in Knowtex.",
            pdf: "/help-guides/pre-charting.pdf",
          },
        ],
      },
    ],
  },
  {
    id: "note-customization",
    title: "Note Customization",
    subtopics: [
      {
        id: "dot-phrases",
        title: "Dot Phrases",
        articles: [
          {
            id: "dot-phrases-guide",
            title: "How to Use Dot Phrases",
            description:
              "Learn how to create and use dot phrases to speed up documentation.",
            pdf: "/help-guides/dot-phrases.pdf",
          },
        ],
      },
      {
        id: "custom-prompting",
        title: "Custom Prompting",
        articles: [
          {
            id: "custom-prompting-guide",
            title: "How to Use Custom Prompting",
            description:
              "Customize AI-generated notes with your own prompting preferences.",
            pdf: "/help-guides/custom-prompting.pdf",
          },
        ],
      },
    ],
  },
];

// Returns the first article in the tree (used as the default selection).
export function getFirstArticle(guides = HELP_GUIDES) {
  for (const topic of guides) {
    for (const subtopic of topic.subtopics || []) {
      for (const article of subtopic.articles || []) {
        return { topicId: topic.id, subtopicId: subtopic.id, article };
      }
    }
  }
  return null;
}

// Looks up an article by id along with its parent topic/subtopic ids.
export function findArticle(articleId, guides = HELP_GUIDES) {
  for (const topic of guides) {
    for (const subtopic of topic.subtopics || []) {
      for (const article of subtopic.articles || []) {
        if (article.id === articleId) {
          return { topicId: topic.id, subtopicId: subtopic.id, article };
        }
      }
    }
  }
  return null;
}
